import { render, staticRenderFns } from "./ReportOtp.vue?vue&type=template&id=2dc2600d&scoped=true&"
import script from "./ReportOtp.vue?vue&type=script&lang=js&"
export * from "./ReportOtp.vue?vue&type=script&lang=js&"
import style0 from "./ReportOtp.vue?vue&type=style&index=0&id=2dc2600d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2600d",
  null
  
)

export default component.exports